module.exports = __webpack_public_path__ + "static/laura-gaetano.bccad377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/laura-gaetano.jpg
// module id = 670
// module chunks = 168707334958949